import { conduitApiFetch, ConduitApiBaseUrl } from "./fetch";

export default class ConduitApiUsers {
  static resetGoal(appId, endUserId) {
    return conduitApiFetch(`${ConduitApiBaseUrl}paths/goal_reset_all?id=${appId}`, {
      headers: {
        "user-id": endUserId,
      },
    });
  }

  static ping(appId, endUserId, params = {}) {
    return conduitApiFetch(`${ConduitApiBaseUrl}ping`, {
      anon: true,
      query: params,
      headers: {
        "user-id": endUserId,
        "Rf-App": appId,
      },
      onResponse: res => {
        if (!res.ok) return null;
        const contentType = res.headers.get("content-type");
        if (contentType?.includes("application/json")) return res.json();
        return res.text().then(text => ({ body: text }));
      },
    });
  }
}
